<template>
  <div>
    <div class="container">
      <h5 class="detail-h5">{{ $t('objectId') }} - {{ $route.params.id }}</h5>

      <div>
        <div class="row">
          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('object') }}</dt>
              <dd class="col-sm-7">{{serviceObject.serviceObjectId}}</dd>

              <dt class="col-sm-5">{{ $t('customerInventoryId') }}</dt>
              <dd class="col-sm-7">{{serviceObject.customerInventoryId}}</dd>

              <dt class="col-sm-5">{{ $t('description') }}</dt>
              <dd class="col-sm-7">{{serviceObject.description}}</dd>

              <dt class="col-sm-5">{{ $t('serialNo') }}</dt>
              <dd class="col-sm-7">{{serviceObject.serialNo}}</dd>

              <dt class="col-sm-5">{{ $t('itemId') }}</dt>
              <dd class="col-sm-7">{{serviceObject.itemId}}</dd>

              <dt class="col-sm-5">{{ $t('contract') }}</dt>
              <dd class="col-sm-7">
                <a
                  v-on:click="contractClick(serviceObject.contractId)"
                  class="row-link"
                >{{serviceObject.contractId}}</a>
              </dd>
            </dl>
          </div>

          <div class="col-sm-6">
            <dl class="row" style="margin-bottom: 0;">
              <dt class="col-sm-5">{{ $t('coverage_type') }}</dt>
              <dd class="col-sm-7">{{serviceObject.coverageType}}</dd>

              <dt class="col-sm-5">{{ $t('installation_date') }}</dt>
              <dd class="col-sm-7">{{serviceObject.installationDate | moment("DD/MM/YYYY")}}</dd>

              <dt class="col-sm-5">{{ $t('warrantyEndDate') }}</dt>
              <dd class="col-sm-7">{{serviceObject.warrantyEndDate | moment("DD/MM/YYYY")}}</dd>

              <dt class="col-sm-5">{{ $t('location') }}</dt>
              <dd class="col-sm-7">{{serviceObject.location}}</dd>

              <dt class="col-sm-5">{{ $t('installation_number') }}</dt>
              <dd class="col-sm-7">{{serviceObject.installationNo}}</dd>

              <dt class="col-sm-5">{{ $t('region_code') }}</dt>
              <dd class="col-sm-7">{{serviceObject.endUserCustomer.customerName}}</dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <h5 class="detail-h5" style="margin-bottom: 0; margin-top: 8px;">{{ $t('calls') }}</h5>

        <small
          v-if="showNewCallOption"
          v-b-toggle="'collapsableAddServiceCall'"
          class="m-2 clear-filter"
        >{{ $t('add_new_call') }}</small>

        <transition name="fade">
          <span class="call-send" v-if="showSuccessMessage">{{ $t('call_has_been_sent') }}</span>
        </transition>

        <b-collapse
          id="collapsableAddServiceCall"
          v-model="showCollapse"
          style="margin-bottom: 32px; margin-top: 32px;"
        >
          <b-card>
            <service-call-add
              v-bind:serviceObject="serviceObject"
              v-on:servicecall-created="handleServiceCallCreated"
            ></service-call-add>
          </b-card>
        </b-collapse>

        <div>
          <b-table
            responsive
            style="margin-top: 16px;"
            show-empty
            :empty-text="$t('no_service_calls_were_found')"
            ref="table"
            :busy.sync="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :per-page="perPage"
            :items="serviceContractsProvider"
            :fields="fields"
            @sort-changed="sortingChanged"
          >
            <template v-slot:table-busy>
              <div style="height: 32px;">
                <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                  <b-spinner></b-spinner>
                </div>
              </div>
            </template>

            <template v-slot:cell(serviceCallId)="data">
              <a
                v-on:click="callClick(data.item.serviceCallId)"
                class="row-link"
              >{{data.item.serviceCallId}}</a>
            </template>

            <template v-slot:cell(openDate)="data">{{data.item.openDate | moment("DD/MM/YYYY")}}</template>

            <template v-slot:cell(closeDate)="data">{{data.item.closeDate | moment("DD/MM/YYYY")}}</template>
          </b-table>

          <div class="row" style="text-align: left; margin-left: 0; margin-right: 0;">
            <div class="col-sm-6 offset-sm-3">
              <b-pagination
                v-if="totalRows > 0"
                align="center"
                label-prev-page="first"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
                style="margin-top: 10px !important"
              />
            </div>
            <div class="col-sm-3">
              <div class="form-group row" style="margin-top: 10px;">
                <label
                  for="inputPassword"
                  class="col-sm-7 col-form-label text-right"
                >{{ $t('lines_per_page') }}</label>
                <div class="col-sm-5">
                  <b-form-select
                    :options="pageOptions"
                    v-model="perPage"
                    :change="rowsPerPageChange()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import ServiceCallAdd from '@/components/service-calls/ServiceCallAdd';
import { bus } from './../../main.js';
import { grid } from './../../mixins/grid.js';

const currentPage = 1;
const filter = '';

export default {
  name: 'ServiceObjectDetail',
  mixins: [odata, grid],
  components: {
    ServiceCallAdd
  },
  data: function() {
    return {
      serviceObject: {
        endUserCustomer: {}
      },
      filter: filter,
      orderString: '',
      isBusy: false,
      sortBy: this.getSortBy(this, 'so-ca-sortBy', 'serviceCallId'),
      sortDesc: this.getSortDesc(this, 'so-ca-sortDesc', false),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: currentPage,
      perPage: this.getPerPage(this, 'so-ca-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(calculateRowsOnScreen()),
      showCollapse: false,
      showSuccessMessage: false,
      showNewCallOption: false
    };
  },
  methods: {
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'so-ca-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var serviceObjectId = this.$route.params.id;

      this.filter = "&$filter=serviceObjectId eq '" + serviceObjectId + "'";

      var url = this.getServiceUr(
        'servicecalls',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(ctx.sortBy, ctx.sortDesc, 'serviceObjectCalls')
      );

      this.setSortBy(this, 'so-ca-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'so-ca-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'so-ca-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'so-ca-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    callClick: function(callNumber) {
      this.$router.push({
        name: 'service-call',
        params: {
          id: callNumber
        }
      });
    },
    contractClick: function(contractNr) {
      this.$router.push({
        name: 'service-contract',
        params: {
          id: contractNr
        }
      });
    },
    handleServiceCallCreated: function(createdServiceCAll) {
      let serviceObjectId = this.$route.params.id;

      getServiceObject(this, serviceObjectId);

      this.showCollapse = false;
      this.showSuccessMessage = true;

      setTimeout(() => {
        this.showSuccessMessage = false;
      }, 2500);

      // refresh table??
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'so-ca-perPage', this.perPage);
    }
  },
  created() {
    let serviceObjectId = this.$route.params.id;

    getServiceObject(this, serviceObjectId);

    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function getServiceObject(context, serviceObjectId) {
  let promise = context.$axios.get(
    'serviceobjects?serviceObjectId=' + serviceObjectId
  );

  return promise
    .then(data => {
      context.serviceObject = data.data;

      getLoginInfo(context, context.serviceObject.companyId);
    })
    .catch(error => {
      console.log(error);
    });
}

function getTableFields(context) {
  return [
    {
      key: 'serviceCallId',
      label: context.$t('call'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'description',
      label: context.$t('description'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'callType',
      label: context.$t('call_type'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'callStatus',
      label: context.$t('call_status'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'openDate',
      label: context.$t('open_date'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'closeDate',
      label: context.$t('close_date'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    }
  ];
}

function calculateRowsOnScreen() {
  var tableHeight = window.innerHeight - 550;

  var maxRows = tableHeight / 40;

  if (maxRows < 3) {
    return 3;
  }

  return Math.floor(maxRows);
}

function getLoginInfo(context, companyId) {
  let promise = context.$axios.get('systemsettings/userinfo ');

  return promise
    .then(data => {
      const logins = data.data;

      var salesGroupsIds = [];
      if (context.serviceObject.contractHolderCustomer !== null) {
        salesGroupsIds.push(
          context.serviceObject.contractHolderCustomer.salesGroupId
        );
      }
      if (context.serviceObject.endUserCustomer !== null) {
        salesGroupsIds.push(context.serviceObject.endUserCustomer.salesGroupId);
      }
      if (context.serviceObject.customer !== null) {
        salesGroupsIds.push(context.serviceObject.customer.salesGroupId);
      }

      var salesGroupLogins = [];
      salesGroupsIds.forEach(sg => {
        logins.forEach(login => {
          if (
            (login.salesGroupId === sg && login.companyId === companyId) ||
            (login.salesGroupId.startsWith('*ALL') &&
              login.companyId === companyId)
          ) {
            salesGroupLogins.push(login);
          }
        });
      });

      salesGroupLogins.forEach(login => {
        if (login.canCreateCall) {
          context.showNewCallOption = true;
        }
      });
    })
    .catch(error => {
      console.log(error);
    });
}
</script>

<style scoped>
.container {
  background-color: white;
  text-align: left;
}

.row-link {
  cursor: pointer;
  font-weight: 700 !important;
}

.object-details {
  text-align: left;
}

.call-send {
  background-color: #00c851;
  color: white;
  padding: 2px 16px;
  font-weight: 400;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
